import { NameResourceItem } from "../NameResourceItem";
import { createListResource } from "../../list";

export class Makroregion extends NameResourceItem {}

export const makroregionResource =
  createListResource<Makroregion>("crm/macroregion/");

export class Region extends NameResourceItem {
  makroregion!: Makroregion;

  constructor(data: any) {
    super(data);
    this.makroregion = new Makroregion(data.makroregion);
  }
}

export const regionResource = createListResource<Region>("crm/region/");
